import { createBrowserRouter, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { RouteLoading } from "@/components/RouteLoading";
import { ROUTES } from "@/constants";
import { Layout } from "@/layouts/Layout";

const Home = lazy(() => import("@/pages/Home"));
const PersonalToken = lazy(() => import("@/pages/personal_token"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const Subscribe = lazy(() => import("@/pages/subscribe"));
const UserAgreement = lazy(() => import("@/pages/user-agreement"));
const PrivacyPolicy = lazy(() => import("@/pages/privacy-policy"));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to='/home' replace />,
  },
  {
    path: ROUTES.HOME,
    element: (
      <Layout>
        <Suspense fallback={<RouteLoading />}>
          <Home />
        </Suspense>
      </Layout>
    ),
  },
  {
    path: ROUTES.PERSONAL_TOKEN,
    element: (
      <Layout>
        <Suspense fallback={<RouteLoading />}>
          <PersonalToken />
        </Suspense>
      </Layout>
    ),
  },
  {
    path: ROUTES.SUBSCRIBE,
    element: (
      <Layout>
        <Suspense fallback={<RouteLoading />}>
          <Subscribe />
        </Suspense>
      </Layout>
    ),
  },
  {
    path: ROUTES.NOT_FOUND,
    element: (
      <Suspense fallback={<RouteLoading />}>
        <NotFound />
      </Suspense>
    ),
  },
  {
    path: ROUTES.USER_AGREEMENT,
    element: (
      <Suspense fallback={<RouteLoading />}>
        <UserAgreement />
      </Suspense>
    ),
  },
  {
    path: ROUTES.PRIVACY_POLICY,
    element: (
      <Suspense fallback={<RouteLoading />}>
        <PrivacyPolicy />
      </Suspense>
    ),
  },

  {
    path: "*",
    element: <Navigate to={ROUTES.NOT_FOUND} replace />,
  },
]);
